import { useRuntimeConfig } from '#app';
import he from 'he';

export const useAdbutlerFallback = () => {

    const { env, songbirdProxy, songbirdFallbackProxy } = useRuntimeConfig().public;

    // Try `run(base)` against the primary songbird proxy; if it fails with a
    // CORS/network error or HTTP 502, retry once against the fallback proxy.
    const withSongbirdFallback = async (run) => {
        try {
            return await run(songbirdProxy);
        } catch (err) {
            const status = err?.response?.status ?? err?.status ?? err?.statusCode;
            const msg = err?.message || "";
            const name = err?.name || "";
            const isCorsOrNetwork =
                name === "FetchError" ||
                msg === "Network Error" ||
                msg.includes("Failed to fetch") ||
                msg.includes("NetworkError") ||
                err?.code === "ERR_NETWORK";
            const shouldFallback = status === 502 || (!status && isCorsOrNetwork);

            if (!shouldFallback || !songbirdFallbackProxy || songbirdFallbackProxy === songbirdProxy) {
                throw err;
            }

            if (env === "dev") {
                console.warn("[songbird] adbutler fallback triggered", { status, msg });
            }
            return await run(songbirdFallbackProxy);
        }
    };

    const fetchFallbackAdbutler = async (adName) => {
        try {
            if (!songbirdProxy) {
                console.warn("Songbird proxy URL not configured for fallback ads");
                return null;
            }

            const response = await withSongbirdFallback((base) =>
                $fetch(`${base}ads/fallback`, {
                    query: {
                        adname: adName
                    }
                })
            );

            if (response && response.success && response.data && response.data.html) {
                // Decode HTML entities to convert &lt;br&gt; to <br>, etc.
                const decodedHtml = he.decode(response.data.html);
                return decodedHtml;
            }

            return null;
        } catch (error) {
            if (env === "dev") {
                console.error(`Error fetching fallback ad for ${adName}:`, error);
            }
            return null;
        }
    };

    return { fetchFallbackAdbutler };
};
